const now = new Date();
const currentMonth = String(now.getMonth() + 1).padStart(2, "0");
const currentYear = String(now.getFullYear());
const firstDay = `${currentYear}-${currentMonth}-01`;
const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
const lastDayStr = `${currentYear}-${currentMonth}-${String(lastDay.getDate()).padStart(2, "0")}`;

export const DEFAULT_REPORT_FILTERS: Record<string, any> = {
  dateStart: firstDay,
  dateEnd: lastDayStr,
  month: currentMonth,
  year: currentYear,
};
